export default {
  nav: {
    technology: "Tecnología ODF",
    solutions: "Soluciones",
    partnerships: "Alianzas",
    about: "Nosotros",
    contact: "Contáctenos",
    home: "Inicio",
  },
  hero: {
    eyebrow: "SOLUCIONES ODF DE NUEVA GENERACIÓN",
    headline1: "Innovación,",
    headline2: "entregada en cada película.",
    copy: "NORTIS acerca películas bucodispersables (Orally Dissolving Films, ODF) de última generación a las marcas de bienestar modernas y a los mercados internacionales, combinando un formato práctico con una experiencia comercial confiable.",
    cta1: "Descubrir la tecnología ODF",
    cta2: "Asociarse con NORTIS",
    trust: "Diseñado para estilos de vida modernos. Creado para oportunidades globales.",
    scroll: "Desplazar",
  },
  brandline: "Entrega avanzada. Experiencia sin esfuerzo.",
  credibility: {
    title: "Un formato más inteligente para un mundo en constante cambio.",
    copy: "Las películas bucodispersables ofrecen una forma refinada y práctica de administrar ingredientes cuidadosamente formulados, sin la experiencia convencional de comprimidos, cápsulas o líquidos.",
  },
  whatIsOdf: {
    eyebrow: "EL FORMATO",
    title: "¿Qué es una ODF?",
    copy: "La ODF es una película oral ultrafina diseñada para disolverse cómodamente en la boca. Su formato compacto ofrece una alternativa moderna a las marcas que desarrollan experiencias de bienestar portátiles y fáciles de usar.",
    benefits: [
      { title: "Fina y portátil", desc: "Un formato ultradelgado que viaja sin esfuerzo: en un bolsillo, una billetera o un bolso." },
      { title: "Uso sin agua", desc: "Diseñada para utilizarse en cualquier lugar y en cualquier momento, sin agua ni preparación." },
      { title: "Presentación precisa", desc: "Cada película es una unidad presentada individualmente, envasada para garantizar la consistencia." },
      { title: "Pensada para la innovación", desc: "Una base flexible para conceptos de producto modernos y experiencias de marca diferenciadas." },
    ],
  },
  whyNortis: {
    eyebrow: "POR QUÉ NORTIS",
    title: "Más que un formato de producto. Una oportunidad de mercado completa.",
    copy: "NORTIS es el puente entre la innovación en ODF y los mercados comerciales: conecta productos prometedores con los socios capaces de escalarlos.",
    points: [
      { title: "Experiencia comercial centrada en ODF", desc: "Un enfoque dedicado a la categoría de películas bucodispersables y a su dinámica comercial." },
      { title: "Abastecimiento internacional y desarrollo de mercados", desc: "Identificar oportunidades y construir rutas de acceso al mercado en distintas regiones." },
      { title: "Apoyo en posicionamiento de producto y marca", desc: "Ayudamos a los socios a adaptar los conceptos ODF a sus audiencias y canales." },
      { title: "Modelos de alianza B2B flexibles", desc: "Distribución, marca propia y desarrollo de mercados, estructurados en torno a sus objetivos." },
      { title: "Selección orientada a la calidad", desc: "Evaluación rigurosa de la idoneidad, la documentación y la preparación para el mercado." },
      { title: "Relaciones a largo plazo", desc: "Alianzas concebidas para un crecimiento comercial duradero y acumulativo." },
    ],
  },
  solutions: {
    eyebrow: "PORTAFOLIO DE SOLUCIONES",
    title: "Un portafolio diseñado en torno a la vida moderna.",
    copy: "Explore las categorías de soluciones que NORTIS desarrolla junto a socios y mercados de todo el mundo.",
    viewAll: "Ver todas las soluciones",
    requestInfo: "Solicitar información del producto",
    possibilitiesLabel: "Posibilidades de desarrollo",
    positioningLabel: "Posicionamiento comercial",
    availabilityLabel: "Disponibilidad en el mercado",
    targetLabel: "Mercado objetivo",
    docLabel: "Estado de la documentación",
    sheetLabel: "Ficha informativa",
    sheetOnRequest: "Disponible a solicitud",
    demoBadge: "Concepto de demostración",
    filterAll: "Todas",
    pageTitle: "Soluciones",
    pageSub: "Un portafolio filtrable de categorías de soluciones ODF, estructurado para incorporar productos reales a medida que avanzan las alianzas.",
    demoNote: "Las entradas siguientes son conceptos de demostración que ilustran la dirección de cada categoría. Los productos comerciales reales se presentan en el marco de alianzas activas.",
  },
  comparison: {
    eyebrow: "EXPERIENCIA DEL FORMATO",
    title: "Cómo se compara el formato de película.",
    copy: "Una mirada neutral a las características prácticas de los formatos cotidianos.",
    note: "Comparación neutral únicamente de características prácticas del formato. No constituye una afirmación de rendimiento clínico ni de eficacia.",
    formats: ["Película ODF", "Comprimidos", "Cápsulas", "Líquidos"],
    rows: [
      { label: "Portabilidad", values: [2, 2, 2, 0] },
      { label: "Uso sin agua", values: [2, 0, 0, 1] },
      { label: "Formato individual predosificado", values: [2, 2, 2, 0] },
      { label: "Facilidad de almacenamiento", values: [2, 2, 1, 0] },
      { label: "Experiencia discreta en movimiento", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "MODELOS DE ALIANZA",
    title: "Tres formas de crecer con NORTIS.",
    cta: "Conversar sobre una alianza",
    items: [
      { title: "Distribución", desc: "Lleve productos ODF seleccionados a nuevos territorios y redes comerciales." },
      { title: "Marca propia", desc: "Desarrolle conceptos ODF diferenciados bajo su propia marca." },
      { title: "Desarrollo de mercados", desc: "Construya con NORTIS el posicionamiento del producto, la estrategia de lanzamiento y una presencia de mercado duradera." },
    ],
  },
  timeline: {
    eyebrow: "CÓMO FUNCIONA LA COLABORACIÓN",
    title: "De la primera conversación al crecimiento en el mercado.",
    steps: [
      { title: "Descubrimiento de oportunidades", desc: "Exploramos sus objetivos, sus mercados y los conceptos ODF que mejor se ajustan a ellos." },
      { title: "Alineación de producto y mercado", desc: "Emparejamos los productos adecuados con el contexto comercial adecuado." },
      { title: "Evaluación comercial", desc: "Estructuramos condiciones, volúmenes y un marco comercial realista." },
      { title: "Cumplimiento y preparación del lanzamiento", desc: "Revisamos la documentación y los requisitos del mercado antes del lanzamiento." },
      { title: "Distribución y crecimiento", desc: "Acompañamos el despliegue, la expansión y el crecimiento de la alianza a largo plazo." },
    ],
  },
  quality: {
    eyebrow: "CALIDAD Y RESPONSABILIDAD",
    title: "La calidad empieza con las preguntas correctas.",
    copy: "NORTIS evalúa la idoneidad del producto, la documentación, la preparación comercial y los requisitos del mercado como parte de cada alianza potencial. La disponibilidad de los productos y su situación regulatoria pueden variar según el país.",
    placeholder: "La documentación de calidad verificada y las certificaciones se publicarán aquí a medida que avancen las alianzas.",
  },
  global: {
    eyebrow: "VISIÓN GLOBAL",
    title: "Creados para la colaboración internacional",
    copy: "Trabajamos con marcas, proveedores, distribuidores y socios comerciales para identificar oportunidades ODF relevantes en mercados globales en constante evolución.",
  },
  finalCta: {
    title: "Demos forma juntos a la próxima generación del bienestar oral.",
    copy: "Ya sea que explore la distribución, la marca propia o un nuevo concepto de producto ODF, NORTIS está listo para iniciar la conversación.",
    cta: "Iniciar una conversación",
  },
  footer: {
    desc: "NORTIS conecta productos ODF innovadores con marcas, socios y mercados de todo el mundo.",
    nav: "Navegación",
    legal: "Legal",
    privacy: "Política de privacidad",
    terms: "Términos de uso",
    language: "Idioma",
    disclaimer: "La disponibilidad, formulación, clasificación y situación regulatoria de los productos pueden variar según el país. La información de este sitio web tiene fines comerciales y de información general, y no constituye asesoramiento médico.",
    rights: "Todos los derechos reservados.",
  },
  tech: {
    eyebrow: "TECNOLOGÍA ODF",
    title: "La ciencia de lo ultrafino.",
    sub: "Una visión educativa de la película bucodispersable: el formato, la experiencia y las posibilidades comerciales que abre.",
    what: {
      title: "¿Qué es una película bucodispersable?",
      copy: "Una película bucodispersable (ODF) es una lámina ultrafina diseñada para disolverse cómodamente en la boca. En lugar de tragar un comprimido o medir un líquido, el usuario simplemente coloca una película y deja que se disuelva: una experiencia discreta y moderna en un formato notablemente compacto.",
    },
    structure: {
      title: "La estructura general de la película",
      copy: "Conceptualmente, una ODF combina una base estructural, una matriz portadora que contiene los ingredientes formulados y una capa sensorial que define el sabor y la textura. Pase el cursor o toque el diagrama para separar las capas conceptuales.",
      note: "Representación conceptual, únicamente con fines ilustrativos.",
      layers: [
        { title: "Capa sensorial", desc: "Define el sabor, la textura y la experiencia de disolución." },
        { title: "Matriz portadora", desc: "Contiene los ingredientes cuidadosamente formulados dentro de la película." },
        { title: "Base estructural", desc: "Aporta a la película su integridad, su delgadez y su estabilidad." },
      ],
    },
    experience: {
      title: "La experiencia del usuario",
      copy: "Sin agua. Sin mediciones. Sin interrupciones. La película se disuelve discretamente, lo que hace natural su uso al viajar, trabajar o estar en movimiento. Para el consumidor moderno, el propio formato se convierte en parte de la experiencia de marca.",
    },
    portability: {
      title: "Portabilidad y potencial de envasado",
      copy: "Las películas individuales pueden presentarse en sobres delgados, elegantes envases múltiples o dispensadores compactos: formatos que encajan tanto en los estantes del comercio moderno como en las experiencias de unboxing de la venta directa al consumidor.",
    },
    development: {
      title: "Posibilidades de desarrollo de producto",
      copy: "El formato de película admite una amplia gama de conceptos de producto, desde rutinas de bienestar diario hasta posicionamientos de estilo de vida específicos, dando a las marcas espacio para diferenciarse en categorías saturadas.",
    },
    commercial: {
      title: "Aplicaciones comerciales",
      copy: "Los conceptos ODF se están desarrollando en las categorías de bienestar, belleza desde el interior, energía, sueño e ingredientes funcionales: canales donde la comodidad y la experiencia premium impulsan las decisiones de compra.",
    },
    regulatory: {
      title: "Consideraciones regulatorias y de mercado",
      copy: "La clasificación y los requisitos de los productos en formato de película difieren según el país y la formulación. NORTIS aborda cada mercado de forma individual, revisando la documentación y el contexto regulatorio junto a sus socios antes de la comercialización.",
    },
    cta: "Solicitar información técnica",
  },
  partnership: {
    eyebrow: "MARCA PROPIA Y DISTRIBUCIÓN",
    title: "Dos caminos. Un mismo estándar de colaboración.",
    sub: "NORTIS estructura sus colaboraciones comerciales en torno a dos modelos principales, ambos diseñados para la claridad, la rapidez y el crecimiento a largo plazo.",
    plTitle: "Marca propia",
    plDesc: "Desarrolle conceptos ODF diferenciados bajo su propia marca, con NORTIS coordinando el recorrido desde el concepto hasta el punto de venta.",
    plSteps: ["Evaluación del concepto", "Selección de productos", "Coordinación de marca y envase", "Revisión de la documentación", "Preparación del lanzamiento", "Escalado comercial"],
    distTitle: "Distribución",
    distDesc: "Lleve productos ODF seleccionados a su territorio y a su red comercial, con apoyo estructurado en cada etapa.",
    distSteps: ["Evaluación del territorio", "Alineación del portafolio", "Condiciones comerciales", "Planificación de la entrada al mercado", "Apoyo al lanzamiento", "Crecimiento a largo plazo"],
    formTitle: "Iniciar una solicitud de alianza",
    formSub: "Cuéntenos sus objetivos y nuestro equipo le responderá con los próximos pasos.",
  },
  about: {
    eyebrow: "SOBRE NORTIS",
    title: "Enfocados en el formato que definirá el mañana.",
    copy: "NORTIS nació para conectar innovaciones ODF prometedoras con las marcas, los socios y los mercados capaces de convertirlas en productos comerciales relevantes. Combinamos rapidez emprendedora, visión internacional y un enfoque disciplinado hacia las alianzas de largo plazo.",
    positioning: "NORTIS conecta productos ODF innovadores con marcas, socios y mercados de todo el mundo.",
    principlesTitle: "Nuestros principios",
    principles: [
      { title: "Precisión", desc: "Cuidado en cada detalle, desde la evaluación del producto hasta la comunicación con los socios." },
      { title: "Confianza", desc: "Expectativas transparentes y compromisos que pretendemos cumplir." },
      { title: "Progreso", desc: "Una clara orientación hacia el avance y los formatos modernos." },
      { title: "Colaboración", desc: "Relaciones diseñadas para crecer durante años, no trimestres." },
      { title: "Perspectiva global", desc: "Pensar más allá de fronteras, mercados y culturas de consumo." },
    ],
  },
  contact: {
    eyebrow: "CONTACTO",
    title: "Iniciemos la conversación.",
    sub: "Comparta algunos detalles sobre su interés y nuestro equipo se pondrá en contacto con usted.",
    name: "Nombre completo",
    company: "Empresa",
    email: "Correo electrónico corporativo",
    country: "País",
    website: "Sitio web",
    interest: "Interés de colaboración",
    market: "Mercado o territorio previsto",
    message: "Mensaje",
    consent: "Autorizo a NORTIS a almacenar mis datos con el fin de responder a esta consulta.",
    submit: "Enviar mensaje",
    sending: "Enviando…",
    successTitle: "Gracias — hemos recibido su mensaje.",
    successCopy: "Nuestro equipo revisará su consulta y se pondrá en contacto con usted a la brevedad.",
    successAnother: "Enviar otro mensaje",
    errorRequired: "Este campo es obligatorio.",
    errorEmail: "Ingrese un correo electrónico corporativo válido.",
    errorConsent: "Se requiere su consentimiento para enviar el formulario.",
    errorSubmit: "Ocurrió un error. Inténtelo de nuevo.",
    optional: "Opcional",
    interests: {
      distribution: "Distribución",
      privateLabel: "Marca propia",
      sourcing: "Abastecimiento de productos",
      marketDev: "Desarrollo de mercados",
      general: "Alianza general",
      product: "Información de producto",
      technical: "Información técnica",
    },
    selectPlaceholder: "Seleccione una opción",
  },
  legal: {
    privacyTitle: "Política de privacidad",
    termsTitle: "Términos de uso",
    updated: "Última actualización",
    privacy: [
      { h: "1. Descripción general", p: "Esta Política de privacidad explica cómo NORTIS recopila, utiliza y protege la información enviada a través de este sitio web. Nos comprometemos a tratar los datos de contacto comerciales de manera responsable y transparente." },
      { h: "2. Información que recopilamos", p: "Cuando envía un formulario de contacto o de alianza, recopilamos la información que usted proporciona, como su nombre, empresa, correo electrónico corporativo, país, sitio web, área de interés y el contenido del mensaje." },
      { h: "3. Cómo utilizamos la información", p: "La información enviada se utiliza únicamente para responder a su consulta, evaluar una posible colaboración comercial y comunicarnos con usted sobre asuntos de alianza pertinentes. No vendemos información personal." },
      { h: "4. Almacenamiento y seguridad de los datos", p: "Los envíos de formularios se almacenan de forma segura en la base de datos de nuestra aplicación. El acceso está limitado al personal que lo necesita para responder a las consultas. Adoptamos medidas técnicas razonables para proteger los datos almacenados." },
      { h: "5. Conservación de los datos", p: "Conservamos los datos de las consultas durante el tiempo necesario para gestionar la relación comercial o según lo exija la legislación aplicable. Puede solicitar la eliminación de sus datos contactándonos." },
      { h: "6. Sus derechos", p: "Según su jurisdicción, puede tener derecho a acceder, rectificar o eliminar los datos personales que conservamos sobre usted. Para ejercer estos derechos, contáctenos a través del sitio web." },
      { h: "7. Cambios en esta política", p: "Podemos actualizar esta Política de privacidad ocasionalmente. Los cambios sustanciales se reflejarán en esta página con una fecha de revisión actualizada." },
    ],
    terms: [
      { h: "1. Aceptación de los términos", p: "Al acceder a este sitio web y utilizarlo, usted acepta estos Términos de uso. Si no está de acuerdo, le pedimos que deje de utilizar el sitio." },
      { h: "2. Finalidad informativa", p: "El contenido de este sitio web se ofrece únicamente con fines comerciales y de información general. No constituye asesoramiento médico, legal ni regulatorio, y ningún contenido debe interpretarse como una declaración sobre productos." },
      { h: "3. Disponibilidad de los productos", p: "La disponibilidad, formulación, clasificación y situación regulatoria de los productos pueden variar según el país. Nada en este sitio web constituye una oferta de venta de producto alguno en una jurisdicción específica." },
      { h: "4. Propiedad intelectual", p: "El nombre NORTIS, la identidad visual y el contenido del sitio web son propiedad de NORTIS. No puede reproducir ni distribuir el contenido del sitio sin autorización previa por escrito." },
      { h: "5. Limitación de responsabilidad", p: "NORTIS realiza esfuerzos razonables para mantener la exactitud de la información del sitio web, pero no garantiza su integridad. En la medida permitida por la ley, NORTIS no se hace responsable de las decisiones tomadas con base en el contenido del sitio." },
      { h: "6. Enlaces de terceros", p: "Este sitio web puede contener enlaces a recursos de terceros. NORTIS no es responsable del contenido ni de las prácticas de los sitios externos." },
      { h: "7. Vigencia de los términos", p: "Estos términos pueden actualizarse periódicamente. El uso continuado del sitio web implica la aceptación de la versión vigente." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Soluciones ODF avanzadas | Socio en películas bucodispersables", desc: "NORTIS conecta productos innovadores de películas bucodispersables (ODF) con marcas, socios y mercados de todo el mundo. Distribución, marca propia y desarrollo de mercados." },
    tech: { title: "Tecnología ODF — NORTIS", desc: "Una visión educativa de la tecnología de películas bucodispersables: formato, estructura, experiencia de usuario y posibilidades comerciales." },
    solutions: { title: "Portafolio de soluciones ODF — NORTIS", desc: "Explore las categorías de soluciones ODF: bienestar diario, energía, belleza, sueño, ingredientes funcionales y conceptos de marca propia a medida." },
    partnership: { title: "Marca propia y distribución — NORTIS", desc: "Asóciese con NORTIS mediante modelos de distribución, marca propia o desarrollo de mercados para productos ODF." },
    about: { title: "Sobre NORTIS — Enfocados en el formato del mañana", desc: "NORTIS conecta innovaciones ODF prometedoras con las marcas, socios y mercados capaces de convertirlas en productos comerciales." },
    contact: { title: "Contactar a NORTIS — Iniciar una conversación", desc: "Comuníquese con el equipo de NORTIS para hablar sobre distribución ODF, marca propia, abastecimiento o desarrollo de mercados." },
    privacy: { title: "Política de privacidad — NORTIS", desc: "Cómo NORTIS recopila, utiliza y protege la información enviada a través de este sitio web." },
    terms: { title: "Términos de uso — NORTIS", desc: "Términos que rigen el uso del sitio web de NORTIS y su contenido informativo." },
  },
  a11y: {
    mainNav: "Navegación principal",
    mobileNav: "Navegación móvil",
    homeLink: "Inicio de NORTIS",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    langSelector: "Seleccionar idioma",
    filmDiagram: "Diagrama interactivo de las capas de la película",
    linkedinLabel: "NORTIS en LinkedIn",
    techImageAlt: "Láminas de película superpuestas abstractas",
    yes: "Sí",
    partial: "Parcial",
    no: "No",
    filters: "Filtros de soluciones",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Bienestar diario",
      desc: "Conceptos de películas cotidianas diseñados para integrarse de forma natural en las rutinas modernas de mañana y noche.",
      possibilities: ["Líneas de producto basadas en rutinas", "Formatos aptos para suscripción", "Envase premium minimalista"],
      positioning: "Posicionado para consumidores que buscan una constancia diaria sin esfuerzo.",
      availability: "En desarrollo con socios",
      targetMarket: "Comercio de bienestar y estilo de vida",
      docStatus: "Preparada por mercado",
    },
    "energy-performance": {
      name: "Energía y rendimiento",
      desc: "Conceptos para llevar, pensados para consumidores que valoran el impulso: antes de entrenar, viajar o afrontar un día exigente.",
      possibilities: ["Posicionamiento previo a la actividad", "Formatos multipack compactos", "Lenguaje de marca audaz y moderno"],
      positioning: "Creado para momentos de consumo rápidos y guiados por la comodidad.",
      availability: "En desarrollo con socios",
      targetMarket: "Canales de vida activa y deporte",
      docStatus: "Preparada por mercado",
    },
    "beauty-aging": {
      name: "Belleza y envejecimiento saludable",
      desc: "Conceptos de películas elegantes para la categoría de belleza desde el interior, donde la experiencia y la estética importan.",
      possibilities: ["Posicionamiento de belleza premium", "Conceptos de envase para regalo", "Narrativa de marca basada en rituales"],
      positioning: "Un formato refinado para marcas que elevan el ritual de belleza diario.",
      availability: "En desarrollo con socios",
      targetMarket: "Belleza desde el interior y comercio premium",
      docStatus: "Preparada por mercado",
    },
    "sleep-relaxation": {
      name: "Sueño y relajación",
      desc: "Conceptos serenos, orientados a la noche, diseñados en torno a la sencillez al final del día.",
      possibilities: ["Posicionamiento como ritual nocturno", "Formatos discretos para la mesita de noche", "Diseño sensorial relajante"],
      positioning: "Creado para el momento de calma previo al descanso.",
      availability: "En desarrollo con socios",
      targetMarket: "Bienestar nocturno y farmacias",
      docStatus: "Preparada por mercado",
    },
    "vitamins-functional": {
      name: "Vitaminas e ingredientes funcionales",
      desc: "Conceptos de películas construidos en torno a ingredientes funcionales reconocidos, presentados en un formato moderno y preciso.",
      possibilities: ["Familias de productos centradas en ingredientes", "Diseño de etiqueta claro y honesto", "Diferenciación a través del formato"],
      positioning: "Una alternativa contemporánea dentro de categorías de ingredientes consolidadas.",
      availability: "En desarrollo con socios",
      targetMarket: "Comercio nutracéutico y funcional",
      docStatus: "Preparada por mercado",
    },
    "custom-private-label": {
      name: "Conceptos a medida y de marca propia",
      desc: "Un lienzo en blanco: conceptos ODF a medida desarrollados bajo la marca del socio, desde la idea hasta el lanzamiento.",
      possibilities: ["Desarrollo de conceptos totalmente a medida", "Coordinación de marca y envase", "Apoyo al lanzamiento y al escalado"],
      positioning: "Para socios que desean un producto diferenciado e inconfundiblemente suyo.",
      availability: "Abierto a propuestas",
      targetMarket: "Propietarios de marcas y minoristas",
      docStatus: "Definida por proyecto",
    },
  },
};
